import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import {
    Box,
    TextField,
    FormControl,
    Grid,
    Button,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Tooltip
} from "@mui/material";
import { AddTransportAllowanceAction, UpdateTransportAllowanceAction } from "../../../../../../store/Finance/PayRollTemplate/Action";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TransportAllowance = ({ editedRecord, setOpenPopup }) => {
    const dispatch = useDispatch();
    const initialValue = {
        transport_allowance_type: "",
        flat_amount: "",
        variable_transport_allowance_rate: "",
    };
    const [transportAllowance, setTransportAllowance] = useState(initialValue);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (editedRecord != null) {
            setTransportAllowance({
                ...editedRecord,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editedRecord]);
    const validate = (fieldValues = transportAllowance) => {
        let temp = { ...errors };

        if ("transport_allowance_type" in fieldValues)
            temp.transport_allowance_type = fieldValues.transport_allowance_type ? "" : "Transport Allowance type is required.";

        if ("flat_amount" in fieldValues && transportAllowance.transport_allowance_type === "Flat")
            temp.flat_amount = fieldValues.flat_amount ? "" : "Flat amount is required.";

        if ("variable_transport_allowance_rate" in fieldValues && transportAllowance.transport_allowance_type === "Variable")
            temp.variable_transport_allowance_rate = fieldValues.variable_transport_allowance_rate
                ? ""
                : "Transport Allowance rate is required.";

        setErrors({ ...temp });

        return Object.values(temp).every((x) => x === "");
    };
    const handleInput = (event, value) => {
        if (event.target.name === "transport_allowance_type") {
            if (event.target.value === "Flat") {
                setTransportAllowance({
                    ...transportAllowance,
                    transport_allowance_type: event.target.value,
                    variable_transport_allowance_rate: "",
                });
            } else  {
                setTransportAllowance({
                    ...transportAllowance,
                    [event.target.name]: event.target.value,
                    flat_amount: "",
                });
            }
            setErrors({})
        }
        else {
            setTransportAllowance({
                ...transportAllowance,
                [event.target.name]: event.target.value,
            });
            Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
                validate({
                    ...transportAllowance,
                    [event.target.name]: event.target.value,
                })
        }

    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validate()) {
            if (editedRecord?.transport_allowance_configuration_pk) {
                dispatch(UpdateTransportAllowanceAction({
                    ...transportAllowance,
                }));
            }
            else {
                dispatch(
                    AddTransportAllowanceAction({
                        ...transportAllowance,
                    })
                );
            }
            setOpenPopup(false);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth error={!!errors?.transport_allowance_type} size="small">
                        <InputLabel id="transport_allowance-label">Transport Allowance Type *</InputLabel>
                        <Select
                            labelId="transportAllowance-type-label"
                            name="transport_allowance_type"
                            value={transportAllowance?.transport_allowance_type}
                            label="Transport Allowance Type"
                            onChange={handleInput}
                        >
                            <MenuItem value="Flat">Flat</MenuItem>
                            <MenuItem value="Variable">Variable</MenuItem>
                        </Select>
                        <FormHelperText>{errors?.transport_allowance_type}</FormHelperText>
                    </FormControl>
                </Grid>
                {transportAllowance?.transport_allowance_type === "Flat" && (
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            required
                            type="number"
                            value={transportAllowance?.flat_amount}
                            onChange={handleInput}
                            variant="outlined"
                            fullWidth
                            id="flat_amount"
                            label="Amount / Month"
                            name="flat_amount"
                            autoComplete="flat_amount"
                            InputProps={{
                                endAdornment: (
                                    <Tooltip title="A fixed monthly amount that is pro-rated based on employee attendance.">
                                        <InfoOutlinedIcon fontSize="small" color="action" style={{ cursor: "pointer" }} />
                                    </Tooltip>
                                ),
                            }}
                            {...(errors.flat_amount && {
                                error: true,
                                helperText: errors.flat_amount,
                            })}
                        />
                    </Grid>
                )}
                {transportAllowance?.transport_allowance_type === "Variable" && (
                        <Grid item xs={12} md={6}>
                            <TextField
                                size="small"
                                required
                                type="number"
                                value={transportAllowance?.variable_transport_allowance_rate}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '' || Number(value) >= 1) {
                                        handleInput(e);
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                                id="variable_transport_allowance_rate"
                                label="Daily Rate"
                                name="variable_transport_allowance_rate"
                                autoComplete="variable_transport_allowance_rate"
                                inputProps={{ min: 1 }}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="A daily travel rate paid for each payable day. In monthly summaries, calculated as daily rate × number of payable days.">
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ cursor: "pointer" }} />
                                        </Tooltip>
                                    ),
                                }}
                                {...(errors.variable_transport_allowance_rate && {
                                    error: true,
                                    helperText: errors.variable_transport_allowance_rate,
                                })}
                            />
                        </Grid>
                )}
            </Grid>
            <Box mt={3} display="flex" justifyContent="flex-end">
                <Button
                    type="submit"
                    variant="contained"
                    size="medium"
                    className="mpl-primary-btn"
                >
                    {editedRecord ? "Update" : "Save"}
                </Button>
            </Box>
        </Box>
    );
};
export default TransportAllowance;
